// extracted by css-extract-rspack-plugin
export default {"toast":"vbyQn5","content":"Jf50DP"};